import React from 'react';
import { EMZI_COLORS, EMZI_RADIUS, EMZI_SPACING, EMZI_SHADOWS } from '../../styles/emziCI';

/**
 * CompactCard Component - EMZI CI Flat v6.3
 * ==========================================
 * Compact card component with flat design
 * 
 * Features:
 * - 20-25% shorter than standard cards
 * - Flat white background
 * - Subtle hover effects
 * - Consistent padding (16px)
 * - Optional click handler
 */

const CompactCard = ({
  children,
  onClick,
  className = '',
  hoverable = true,
  padding = EMZI_SPACING.compact,
  style = {},
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const cardStyles = {
    backgroundColor: EMZI_COLORS.background,
    border: `1px solid ${EMZI_COLORS.border}`,
    borderRadius: EMZI_RADIUS.md,
    padding: padding,
    transition: 'all 0.2s ease',
    cursor: onClick ? 'pointer' : 'default',
    boxShadow: isHovered && hoverable ? EMZI_SHADOWS.md : EMZI_SHADOWS.sm,
    transform: isHovered && hoverable ? 'translateY(-2px)' : 'none',
    ...style,
  };

  return (
    <div
      style={cardStyles}
      className={className}
      onClick={onClick}
      onMouseEnter={() => hoverable && setIsHovered(true)}
      onMouseLeave={() => hoverable && setIsHovered(false)}
    >
      {children}
    </div>
  );
};

export default CompactCard;
